import styled from 'styled-components'

export const CategoryHeaderContainer = styled.header`
  max-width: var(--container-max-width);
  margin: 1rem 2rem;

  @media screen and (min-width: 992px) {
    margin: 1rem auto;
    padding: 0 1.5rem;
    margin-bottom: 0;
    display: flex;
    flex-direction: column;

    /* in Desktop we want the breadcrumb to appear after the page header. Reference: https://velasca.atlassian.net/browse/VER-122 */
    & > div:first-child {
      order: 1;
    }

    & > div:nth-child(2) {
      order: 0;
    }
  }

  .breadcrumbs-header-list {
    margin: 0;
    padding: 2rem 0;
    display: flex;
  }

  .category-description {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

    &.category-description--expanded {
      -webkit-line-clamp: 40;
    }
  }
`

export const QuoteStyleCategoryHeader = styled.div`
  padding: 1.5rem 2rem;
  border-left: 4px solid ${({ theme }) => theme.colors.primary};

  /* adjust style overrides */
  .category-description p span {
    color: ${({ theme }) => theme.colors.text.primary};
    text-decoration: none;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 1;
  }
`

export const ReadMoreButton = styled.button`
  background: none;
  padding: 0;
  margin: 0;
  border: none;
`

export const ControlsPanel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
